import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import {
  TASK_COUNT_FEATURE_KEY,
  TaskCountEffects,
  taskCountReducer,
} from '@lyceo/shared/task-count/data-access';
import { provideEffects } from '@ngrx/effects';
import {
  TASK_COUNT_CONFIG,
  TaskCountConfig,
} from '@lyceo/shared/task-count/util';

export function provideTaskCount(
  config: TaskCountConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: TASK_COUNT_CONFIG, useValue: config },
    provideState(TASK_COUNT_FEATURE_KEY, taskCountReducer),
    provideEffects(TaskCountEffects),
  ]);
}
